import React from "react";

export default function SpacingBox(){
    return(
        <div className="p-4"></div>

    )
}